export default __webpack_public_path__ + "static/media/slider-img-002.19dfed69.png";